import React from 'react';
import { createComponent } from 'effector-react';
import { CheckboxNoFunc } from '@components/Checkbox';
import { $libSelected } from '../stores/libSelected';

const ItemCheckBox = createComponent(
  $libSelected,
  ({ id }: { id: number }, selected) => (
    <CheckboxNoFunc className="flex-shrink-0" checked={selected.includes(id)} />
  )
);

export default ItemCheckBox;
